import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

/* Mini animated SVG per service */
const svgs = {
  saas: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <rect x="8" y="16" width="40" height="28" rx="4" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <rect x="14" y="22" width="12" height="8" rx="2" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="1" strokeOpacity="0.6"/>
      <rect x="30" y="22" width="12" height="3" rx="1.5" fill="#ffffff" fillOpacity="0.8"/>
      <rect x="30" y="27" width="8" height="3" rx="1.5" fill="#ffffff" fillOpacity="0.5"/>
      <circle cx="28" cy="10" r="3" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85">
        <animate attributeName="r" values="3;4;3" dur="2s" repeatCount="indefinite"/>
      </circle>
    </svg>
  ),
  ai: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <circle cx="28" cy="28" r="10" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.9"/>
      {[0,60,120,180,240,300].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x2 = 28 + 20 * Math.cos(rad);
        const y2 = 28 + 20 * Math.sin(rad);
        return <line key={i} x1="28" y1="28" x2={x2} y2={y2} stroke="#ffffff" strokeWidth="1" strokeOpacity="0.5"/>;
      })}
      {[0,60,120,180,240,300].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const cx = 28 + 20 * Math.cos(rad);
        const cy = 28 + 20 * Math.sin(rad);
        return <circle key={i} cx={cx} cy={cy} r="3" fill="#ffffff" fillOpacity="0.8">
          <animate attributeName="fill-opacity" values="0.8;0.2;0.8" dur={`${1.5+i*0.3}s`} repeatCount="indefinite"/>
        </circle>;
      })}
    </svg>
  ),
  api: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <rect x="6" y="20" width="16" height="16" rx="3" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <rect x="34" y="20" width="16" height="16" rx="3" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <line x1="22" y1="28" x2="34" y2="28" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.7" strokeDasharray="3 3">
        <animate attributeName="stroke-dashoffset" from="0" to="12" dur="1s" repeatCount="indefinite"/>
      </line>
    </svg>
  ),
  web: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <rect x="10" y="12" width="24" height="36" rx="3" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.75"/>
      <rect x="26" y="20" width="18" height="26" rx="3" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85" fill="#ffffff" fillOpacity="0.1"/>
      <rect x="14" y="16" width="12" height="8" rx="1.5" fill="#ffffff" fillOpacity="0.25"/>
      <rect x="14" y="28" width="8" height="2" rx="1" fill="#ffffff" fillOpacity="0.7"/>
      <rect x="14" y="32" width="6" height="2" rx="1" fill="#ffffff" fillOpacity="0.5"/>
    </svg>
  ),
  payments: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <rect x="8" y="14" width="40" height="28" rx="4" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <line x1="8" y1="22" x2="48" y2="22" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.5"/>
      <rect x="14" y="28" width="10" height="5" rx="1.5" fill="#ffffff" fillOpacity="0.75"/>
      <circle cx="37" cy="31" r="3.5" fill="#ffffff" fillOpacity="0.6">
        <animate attributeName="r" values="3;4.5;3" dur="2s" repeatCount="indefinite"/>
      </circle>
      <circle cx="43" cy="31" r="3.5" stroke="#ffffff" strokeWidth="1" strokeOpacity="0.7"/>
    </svg>
  ),
  automation: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <circle cx="28" cy="28" r="18" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.6" strokeDasharray="4 4">
        <animateTransform attributeName="transform" type="rotate" from="0 28 28" to="360 28 28" dur="8s" repeatCount="indefinite"/>
      </circle>
      <circle cx="28" cy="28" r="7" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <line x1="28" y1="21" x2="28" y2="25" stroke="#ffffff" strokeWidth="2" strokeOpacity="0.8" strokeLinecap="round">
        <animateTransform attributeName="transform" type="rotate" from="0 28 28" to="360 28 28" dur="2s" repeatCount="indefinite"/>
      </line>
    </svg>
  ),
  agents: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <circle cx="28" cy="14" r="5.5" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <circle cx="14" cy="38" r="5.5" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <circle cx="42" cy="38" r="5.5" stroke="#ffffff" strokeWidth="1.5" strokeOpacity="0.85"/>
      <circle cx="28" cy="28" r="4" fill="#ffffff" fillOpacity="0.9">
        <animate attributeName="r" values="3.5;5;3.5" dur="2s" repeatCount="indefinite"/>
      </circle>
      <line x1="28" y1="19.5" x2="28" y2="24" stroke="#ffffff" strokeWidth="1.2" strokeOpacity="0.6"/>
      <line x1="18.5" y1="34" x2="24.5" y2="30.5" stroke="#ffffff" strokeWidth="1.2" strokeOpacity="0.6"/>
      <line x1="37.5" y1="34" x2="31.5" y2="30.5" stroke="#ffffff" strokeWidth="1.2" strokeOpacity="0.6"/>
      <circle cx="28" cy="14" r="2" fill="#ffffff" fillOpacity="0.7"/>
      <circle cx="14" cy="38" r="2" fill="#ffffff" fillOpacity="0.7"/>
      <circle cx="42" cy="38" r="2" fill="#ffffff" fillOpacity="0.7"/>
    </svg>
  ),
  marketing: (
    <svg viewBox="0 0 56 56" fill="none" style={{ width: 28, height: 28 }}>
      <path d="M10 44 L20 30 L30 36 L46 16" stroke="#ffffff" strokeWidth="2" strokeOpacity="0.9" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M38 16 L46 16 L46 24" stroke="#ffffff" strokeWidth="2" strokeOpacity="0.9" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="46" cy="16" r="3" fill="#ffffff" fillOpacity="0.9">
        <animate attributeName="r" values="3;4.5;3" dur="1.8s" repeatCount="indefinite"/>
      </circle>
      <line x1="10" y1="46" x2="48" y2="46" stroke="#ffffff" strokeWidth="1" strokeOpacity="0.3"/>
      <line x1="10" y1="14" x2="10" y2="46" stroke="#ffffff" strokeWidth="1" strokeOpacity="0.3"/>
      <rect x="18" y="38" width="4" height="6" fill="#ffffff" fillOpacity="0.25" rx="1"/>
      <rect x="28" y="32" width="4" height="12" fill="#ffffff" fillOpacity="0.35" rx="1"/>
      <rect x="38" y="24" width="4" height="20" fill="#ffffff" fillOpacity="0.5" rx="1"/>
    </svg>
  ),
};

const services = [
  { svgKey: 'saas', title: 'SaaS Product Development', desc: 'End-to-end architecture and engineering for multi-tenant, cloud-native SaaS platforms built to scale infinitely.' },
  { svgKey: 'payments', title: 'Payment & Billing Platforms', desc: 'Enterprise payment gateway integrations, recurring subscription billing, automated invoicing, plan upgrades/downgrades, and smart failed-payment recovery.' },
  { svgKey: 'ai',   title: 'AI & RAG Systems',          desc: 'Deep integration of LLMs and Retrieval-Augmented Generation architectures into the core of your business logic.' },
  { svgKey: 'agents', title: 'Autonomous AI Agents',    desc: 'Self-governing multi-agent swarms and intelligent autonomous workflows that execute complex tasks, customer ops, and business decisions 24/7.' },
  { svgKey: 'marketing', title: 'AI Digital Marketing & Growth', desc: 'High-velocity digital marketing engines, programmatic SEO pipelines, and algorithmic ad optimization for explosive client acquisition.' },
  { svgKey: 'api',  title: 'Bulk API Infrastructure',    desc: 'Enterprise-grade API microservices engineered for zero-latency, high-throughput data orchestration at global scale.' },
  { svgKey: 'web',  title: 'Web & Mobile Applications',  desc: 'High-performance cross-platform digital products, engineered for absolute fluidity and seamless user experiences.' },
  { svgKey: 'automation', title: 'Enterprise Automation', desc: 'Intelligent workflow automation replacing manual labor with precise, secure, and scalable automated systems.' },
];

const Services = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="section" id="services" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={visible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="section-label">Capabilities</p>
          <h2 className="section-title">Built to scale.<br /><span className="muted">Designed to last.</span></h2>
          <p className="section-subtitle">We don't just write code. We engineer comprehensive digital ecosystems that push technical boundaries.</p>
        </motion.div>

        <div className="services-grid">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              className="service-card"
              initial={{ opacity: 0, y: 40 }}
              animate={visible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.08 * i, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="service-icon">{svgs[s.svgKey]}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
